/** US state options and helpers for structured delivery address fields. */

export const US_STATE_OPTIONS = [
  ['AL', 'Alabama'],
  ['AK', 'Alaska'],
  ['AZ', 'Arizona'],
  ['AR', 'Arkansas'],
  ['CA', 'California'],
  ['CO', 'Colorado'],
  ['CT', 'Connecticut'],
  ['DE', 'Delaware'],
  ['FL', 'Florida'],
  ['GA', 'Georgia'],
  ['HI', 'Hawaii'],
  ['ID', 'Idaho'],
  ['IL', 'Illinois'],
  ['IN', 'Indiana'],
  ['IA', 'Iowa'],
  ['KS', 'Kansas'],
  ['KY', 'Kentucky'],
  ['LA', 'Louisiana'],
  ['ME', 'Maine'],
  ['MD', 'Maryland'],
  ['MA', 'Massachusetts'],
  ['MI', 'Michigan'],
  ['MN', 'Minnesota'],
  ['MS', 'Mississippi'],
  ['MO', 'Missouri'],
  ['MT', 'Montana'],
  ['NE', 'Nebraska'],
  ['NV', 'Nevada'],
  ['NH', 'New Hampshire'],
  ['NJ', 'New Jersey'],
  ['NM', 'New Mexico'],
  ['NY', 'New York'],
  ['NC', 'North Carolina'],
  ['ND', 'North Dakota'],
  ['OH', 'Ohio'],
  ['OK', 'Oklahoma'],
  ['OR', 'Oregon'],
  ['PA', 'Pennsylvania'],
  ['RI', 'Rhode Island'],
  ['SC', 'South Carolina'],
  ['SD', 'South Dakota'],
  ['TN', 'Tennessee'],
  ['TX', 'Texas'],
  ['UT', 'Utah'],
  ['VT', 'Vermont'],
  ['VA', 'Virginia'],
  ['WA', 'Washington'],
  ['WV', 'West Virginia'],
  ['WI', 'Wisconsin'],
  ['WY', 'Wyoming'],
];

export const EMPTY_DELIVERY_ADDRESS = {
  delivery_address: '',
  delivery_city: '',
  delivery_state: 'WA',
  delivery_zip: '',
};

export function deliveryAddressFromProfile(profile) {
  if (!profile) return { ...EMPTY_DELIVERY_ADDRESS };
  return {
    delivery_address: profile.address || '',
    delivery_city: profile.city || '',
    delivery_state: profile.state || 'WA',
    delivery_zip: profile.zip_code || '',
  };
}

/** Single-line delivery address for quotes, jobs, and maps. */
export function formatDeliveryAddressLine({
  delivery_address,
  delivery_city,
  delivery_state,
  delivery_zip,
}) {
  const street = (delivery_address || '').trim();
  if (!street) return '';
  const city = (delivery_city || '').trim();
  const state = (delivery_state || '').trim();
  const zip = (delivery_zip || '').trim();
  return `${street}${city ? `, ${city}` : ''}${state ? `, ${state}` : ''}${zip ? ` ${zip}` : ''}`.trim();
}

export function isDeliveryAddressComplete({
  delivery_address,
  delivery_city,
  delivery_state,
  delivery_zip,
}) {
  return Boolean(
    (delivery_address || '').trim() &&
      (delivery_city || '').trim() &&
      (delivery_state || '').trim() &&
      (delivery_zip || '').trim()
  );
}
